import { PageSize } from "../../types/schema";

const getNumberForPageSize = (pageSize: PageSize): number => {
  switch (pageSize) {
    case PageSize.Fifty:
      return 50;
    case PageSize.Hundred:
      return 100;
    case PageSize.TwoHundred:
      return 200;
    case PageSize.FiveHundred:
      return 500;
    default: {
      return 0;
    }
  }
};

export default getNumberForPageSize;
